/**
 * ActionConfigPopup.jsx
 * =====================
 * Modal wrapper for ActionConfigBuilder
 * Used when adding actions to components
 * 
 * Created: 2025-11-20
 */

import React from 'react';
import ActionConfigBuilder from '../../pages/ActionConfigBuilder';

const ActionConfigPopup = ({ isOpen, onClose, onActionSelect }) => {
  if (!isOpen) return null;

  const handleActionSelect = (actionConfig) => {
    if (onActionSelect) {
      onActionSelect(actionConfig);
    }
    if (onClose) {
      onClose();
    }
  };

  return (
    <div style={styles.overlay} onClick={onClose}>
      <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
        <ActionConfigBuilder
          isPopup={true}
          onActionSelect={handleActionSelect}
          onClose={onClose}
        />
      </div>
    </div>
  );
};

// Inline styles
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 10000,
    padding: '20px',
  },
  modal: {
    backgroundColor: '#FFFFFF',
    borderRadius: '12px',
    maxWidth: '900px',
    width: '100%',
    maxHeight: '90vh',
    overflowY: 'auto',
    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)',
    padding: '24px',
  },
};

export default ActionConfigPopup;





